import { FlexRow, MaterialIcon, StyledSearchBar, useDebouncedSearch } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { memo } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { eventReloadState, eventSearchState } from '../../storage/gptStates';
import { StyledTooltip } from '../ui/StyledTooltip';

function GptEventFilters() {
  const { css } = useStyles();
  const { search, setSearch } = useDebouncedSearch(useRecoilState(eventSearchState));
  const setUpdate = useSetRecoilState(eventReloadState);

  const onUpdate = () => {
    setUpdate('update');
  };

  return (
    <FlexRow centered>
      <div className={css({ flex: 1 })}>
        <StyledSearchBar
          name="gpt-events-search"
          value={search}
          onChange={setSearch}
          clearable
          noMargin
        />
      </div>
      <StyledTooltip
        content={'Actualizar'}
        showArrow={false}
      >
        <Button
          size="mini"
          shape="square"
          onClick={onUpdate}
          kind="tertiary"
        >
          <MaterialIcon name={'sync'} />
        </Button>
      </StyledTooltip>
    </FlexRow>
  );
}

export default memo(GptEventFilters);
